<template>
  <el-dialog :close-on-click-modal="false" title="扫码出标信息" :visible.sync="visible" :width="showOfficialPic ? '1200px' : '900px'" class="scan_order_info" :before-close="handleClose">
    <el-row :gutter="20" v-if="scanOrderInfo.allScanCnt">
      <el-col :span="24" style="padding: 0 50px;">
        <div class="grid-content bg-purple emphasize_green" style="font-size: 18px;font-weight: 600;text">
          <div v-if="scanOrderInfo.allScanCnt > scanOrderInfo.scanEnCnt">
            <span>{{ scanOrderInfo.ifRepeat == '01' ? '重复扫码，' : '' }}</span>
            <span class="emphasize_red">
              <span v-if="scanOrderInfo.ifTaoFlag == '01'">套装{{ scanOrderInfo.skuFlag }}，</span>
              <span v-else>非套装{{ scanOrderInfo.skuFlag }}，</span>
            </span>
            <span>共<span class="emphasize_red">{{ scanOrderInfo.allScanCnt }}</span>件，已出<span class="emphasize_red">{{ scanOrderInfo.scanEnCnt }}</span>件，剩<span class="emphasize_red">{{ scanOrderInfo.allScanCnt - scanOrderInfo.scanEnCnt > 0 ? scanOrderInfo.allScanCnt - scanOrderInfo.scanEnCnt : 0 }}</span>件，
            </span>
            <span class="emphasize_red" v-if="scanOrderInfo.ifPackEd == '01'">
              打包装袋<span class="emphasize_green">（{{ scanOrderInfo.dzSkuId }}）</span>,
            </span>
            <span class="emphasize_red">未完成！</span>
          </div>
          <div v-else>
            <span>{{ scanOrderInfo.ifRepeat == '01' ? '重复扫码，' : '' }}</span>
            <span class="emphasize_red">
              <span v-if="scanOrderInfo.ifTaoFlag == '01'">套装{{ scanOrderInfo.skuFlag }}，</span>
              <span v-else>非套装{{ scanOrderInfo.skuFlag }}，</span>
            </span>
            <span>共<span class="emphasize_red">{{ scanOrderInfo.allScanCnt }}</span>件，已出<span class="emphasize_red">{{ scanOrderInfo.scanEnCnt }}</span>件，剩<span class="emphasize_red">{{ scanOrderInfo.allScanCnt - scanOrderInfo.scanEnCnt > 0 ? scanOrderInfo.allScanCnt - scanOrderInfo.scanEnCnt : 0 }}</span>件，
            </span>
            <span class="emphasize_red" v-if="scanOrderInfo.ifPackEd == '01'">
              打包装袋<span class="emphasize_green">（{{ scanOrderInfo.dzSkuId }}）</span>,
            </span>
            <span class="emphasize_red">全部打包出货！</span>
          </div>
        </div>
        <div 
          v-if="scanOrderInfo.mapNote?.LabelType && ['05','10','14','17','19','21','22','23','24','25'].includes(scanOrderInfo.platNo)"
          style="font-size: 18px;font-weight: 600;"
        >{{ LabelTypeMap[scanOrderInfo.mapNote?.LabelType] }}</div>
        <div
          v-if="scanOrderInfo.mapNote?.groupStrText && (['10','14','22'].includes(scanOrderInfo.platNo) || (['19'].includes(scanOrderInfo.platNo) && scanOrderInfo.mapNote?.importType == '04'))"
          style="font-size: 18px;font-weight: 600;"
          class="emphasize_red"
        >
          {{ scanOrderInfo.mapNote.groupStrText }}
          <!-- groupStrUrl 物流面单地址，暂时没用 -->
        </div>
        <div style="display: flex;justify-content: space-between;">
          <div>
            <div class="grid-content bg-purple" style="font-size: 18px;font-weight: 600;">
              <span>
                <span v-if="!['05', '10'].includes(scanOrderInfo.platNo)">{{ scanOrderInfo.mapNote?.ifBoxLabel == '01' ? '有官方面单！' : '无官方面单，暂搁置！' }}</span>
                要求到货时间：{{ scanOrderInfo.mapNote?.lineTimeLast || '-' }}
              </span>
              <span v-if="['18', '19'].includes(scanOrderInfo.platNo)">，邮编：<span class="emphasize_red">{{ scanOrderInfo.mapNote?.zipCode || '-' }}</span></span>
            </div>
            <div class="grid-content bg-purple" style="font-size: 18px;font-weight: 600;">
              <span>备注：
                <span v-if="scanOrderInfo.mapNote?.ifStockOrder == '01'" class="emphasize_red">库存单，无需打包发货！！</span>
                <span class="emphasize_red">{{ scanOrderInfo.mapNote?.remarkOne || '-' }}</span>
              </span>
            </div>
          </div>
          <div style="display: flex;align-items: center;">
            <div style="margin-right:8px;font-size:20px;font-weight: bold;color: #F56C6C;">共<span>{{ scanOrderInfo.allScanCnt }}</span>件</div>
            <!-- 单件单sku 黑色圆形、多件单sku 蓝色三角形、多sku多件 红色正方形 -->
            <div style="font-weight: bold;color: red;font-size: 14px;">
              <div v-if="scanOrderInfo.skuFlag == '(单sku单件)'" class="shape1"></div>
              <div v-if="scanOrderInfo.skuFlag == '(单sku单件)'" style="margin-top: 8px;">单sku单件</div>
              <div v-if="scanOrderInfo.skuFlag == '(单sku多件)'" class="shape2"></div>
              <div v-if="scanOrderInfo.skuFlag == '(单sku多件)'" style="margin-top: 8px;">单sku多件</div>
              <div v-if="scanOrderInfo.skuFlag == '(多sku多件)'" class="shape3"></div>
              <div v-if="scanOrderInfo.skuFlag == '(多sku多件)'" style="margin-top: 8px;">多sku多件</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="display: flex;align-items: center;margin-top: 30px;">
      <el-col :span="showOfficialPic ? 14 : 11">
        <div class="order_tags">
          <el-tag v-if="scanOrderInfo.platNo == '03'" class="tags_item">lazada半托</el-tag>
          <el-tag v-if="scanOrderInfo.platNo == '05'" class="tags_item">temu全托</el-tag>
          <el-tag v-if="['05'].includes(scanOrderInfo.platNo)" class="tags_item">
            <span v-if="scanOrderInfo.mapNote?.temuType == '01'">VMI</span>
            <span v-if="scanOrderInfo.mapNote?.temuType == '02'">JIT</span>
            <span v-if="scanOrderInfo.mapNote?.temuType == '03'">定制</span>
          </el-tag>
          <el-tag v-if="['05'].includes(scanOrderInfo.platNo) && scanOrderInfo.mapNote?.qcReject == '1'" class="tags_item" type="danger">质补单</el-tag>
          <el-tag v-if="scanOrderInfo.platNo == '10'" class="tags_item">tiktok全托</el-tag>
          <el-tag v-if="scanOrderInfo.platNo == '14'" class="tags_item">shein全托</el-tag>
          <el-tag v-if="scanOrderInfo.platNo == '15'" class="tags_item">temu半托</el-tag>
          <el-tag v-if="scanOrderInfo.platNo == '16'" class="tags_item">shein半托</el-tag>
          <el-tag v-if="scanOrderInfo.platNo == '17'" class="tags_item">ozon</el-tag>
          <el-tag v-if="['18', '19'].includes(scanOrderInfo.platNo)" class="tags_item" type="danger">
            <span v-if="scanOrderInfo.platNo == '18'">国外发货</span>
            <span v-if="scanOrderInfo.platNo == '19'">国内发货</span>
            <span v-if="scanOrderInfo.mapNote?.importType == '01'">（标准模版）</span>
            <span v-if="scanOrderInfo.mapNote?.importType == '02'">（tk模版）</span>
            <span v-if="scanOrderInfo.mapNote?.importType == '03'">（亚马逊模版）</span>
            <span v-if="scanOrderInfo.mapNote?.importType == '04'">（速卖通模版）</span>
            <span v-if="scanOrderInfo.mapNote?.importType == '05'">（沃尔玛模版）</span>
            <span v-if="scanOrderInfo.mapNote?.importType == '06'">（Ebay模版）</span>
            <span v-if="scanOrderInfo.mapNote?.importType == '07'">（美客多模版）</span>
            <span v-if="scanOrderInfo.mapNote?.importType == '08'">（ozon模版）</span>
            <span v-if="scanOrderInfo.mapNote?.importType == '09'">（joom模版）</span>
          </el-tag>
          <el-tag v-if="scanOrderInfo.platNo == '20'" class="tags_item">tiktok半托</el-tag>
          <el-tag v-if="scanOrderInfo.platNo == '21'" class="tags_item">美客多</el-tag>
          <el-tag v-if="scanOrderInfo.platNo == '22'" class="tags_item">shopee全托</el-tag>
          <el-tag v-if="scanOrderInfo.platNo == '23'" class="tags_item">wb全托</el-tag>
          <el-tag v-if="scanOrderInfo.platNo == '24'" class="tags_item">wb半托</el-tag>
          <el-tag v-if="scanOrderInfo.platNo == '25'" class="tags_item">Joom全托</el-tag>
          <el-tag v-if="scanOrderInfo.platNo == '26'" class="tags_item">shopee半托</el-tag>
          <el-tag v-if="scanOrderInfo.mapNote?.noLabel == '01'" class="tags_item" type="danger">退货单</el-tag>
          <el-tag v-if="scanOrderInfo.mapNote?.ifResend == '01'" class="tags_item" type="danger">补单</el-tag>
        </div>
        <div style="display:flex;justify-content: space-between;">
          <div style="position: relative;" v-if="showOfficialPic">
            <img style="width: 330px;height: 330px;object-fit: contain;" :src="scanOrderInfo.mapNote?.amazonPicUrl" alt="官方图" @click="toPreview(scanOrderInfo.mapNote?.amazonPicUrl, [scanOrderInfo.mapNote?.amazonPicUrl])">
            <div style="position: absolute;top:0;left:0;padding:6px 10px;background-color: #8071c9;color: #ffffff;font-size: 16px;">官方图</div>
          </div>
          <div style="position: relative;">
            <img style="object-fit: contain;" :class="{ 'w_330': showOfficialPic, 'w_380': !showOfficialPic }" :src="mainPic" alt="效果图" @click="toPreview(mainPic, picBox)">
            <div class="sku-pic-list" :class="{ 'w_330': showOfficialPic, 'w_380': !showOfficialPic }">
              <a class="prev border text-noSelect" @click="prevPage">&lt;</a>
              <a class="next border text-noSelect" @click="nextPage">&gt;</a>
              <div class="items" :class="{ 'w_262': showOfficialPic, 'w_312': !showOfficialPic }">
                <ul>
                  <li v-for="(pic, index) in picBox" :key="index">
                    <div class="index">{{ index + 1 }}</div>
                    <img :class="{ 'img-select': pic === mainPic }" class="img-normal" :src="pic" @mouseover="hoverImg($event, pic)" />
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="showOfficialPic" style="position: absolute;top:0;left:0;padding:6px 10px;background-color: #8071c9;color: #ffffff;font-size: 16px;">生产图</div>
          </div>
        </div>
      </el-col>
      <el-col :span="showOfficialPic ? 10 : 13" class="curr_skuInfo">
        <el-row :gutter="20" v-if="['05'].includes(scanOrderInfo.platNo)">
          <el-col :span="7">
            <div class="grid-content bg-purple">收货仓库：</div>
          </el-col>
          <el-col :span="17">
            <div class="grid-content bg-purple">
              <div class="normal_style" :class="[wareColorClass]">{{ scanOrderInfo.mapNote?.warehousename }}</div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7">
            <div class="grid-content bg-purple">备货单号：</div>
          </el-col>
          <el-col :span="17">
            <div class="grid-content bg-purple">{{ scanOrderInfo.subOrder }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="scanOrderInfo.mapNote?.trackNumber">
          <el-col :span="7">
            <div class="grid-content bg-purple">物流号(后8位)：</div>
          </el-col>
          <el-col :span="17">
            <div class="grid-content bg-purple" style="font-weight: 600;color: #F56C6C;">{{ scanOrderInfo.mapNote?.trackNumber.slice(-8) }}<span v-if="scanOrderInfo.mapNote?.carryName">（{{ scanOrderInfo.mapNote?.carryName }}）</span></div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7">
            <div class="grid-content bg-purple" v-if="scanOrderInfo.platNo == '21'">Pack ID：</div>
            <div class="grid-content bg-purple" v-else>SKU货号：</div>
          </el-col>
          <el-col :span="17">
            <div class="grid-content bg-purple" style="font-weight: 600;color: #F56C6C;" v-if="scanOrderInfo.platNo == '21'">{{ scanOrderInfo.mapNote?.extCode.slice(0, -11) }}<span style="font-weight: 600;font-size: 20px;">{{ scanOrderInfo.mapNote?.extCode.slice(-11) }}</span></div>
            <div class="grid-content bg-purple" style="color: #F56C6C;" v-else>{{ scanOrderInfo.mapNote?.extCode }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7">
            <div class="grid-content bg-purple">接单时间：</div>
          </el-col>
          <el-col :span="17">
            <div class="grid-content bg-purple">{{ scanOrderInfo.mapNote?.lineTime }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7">
            <div class="grid-content bg-purple">包裹号(后8位)：</div>
          </el-col>
          <el-col :span="17">
            <div class="grid-content bg-purple">{{ scanOrderInfo.packageSn ? scanOrderInfo.packageSn.slice(-8) : '' }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7">
            <div class="grid-content bg-purple">扫码编号：</div>
          </el-col>
          <el-col :span="17">
            <div class="grid-content bg-purple">{{ scanOrderInfo.appNo }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7">
            <div class="grid-content bg-purple">定制SKU ID：</div>
          </el-col>
          <el-col :span="17">
            <div class="grid-content bg-purple">{{ scanOrderInfo.dzSkuId }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7">
            <div class="grid-content bg-purple">产品名称：</div>
          </el-col>
          <el-col :span="17">
            <div class="grid-content bg-purple">{{ scanOrderInfo.proName }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7">
            <div class="grid-content bg-purple">颜色尺码：</div>
          </el-col>
          <el-col :span="17">
            <div class="grid-content bg-purple">{{ scanOrderInfo.properVal }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7">
            <div class="grid-content bg-purple emphasize_green">数量：</div>
          </el-col>
          <el-col :span="17">
            <div class="grid-content bg-purple emphasize_red" style="line-height: 20px;font-size: 20px;font-weight: bold;">{{ scanOrderInfo.num }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7">
            <div class="grid-content bg-purple emphasize_green">套数：</div>
          </el-col>
          <el-col :span="17">
            <div class="grid-content bg-purple emphasize_red" style="line-height: 20px;font-size: 20px;font-weight: bold;">{{ scanOrderInfo.taoshu }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7">
            <div class="grid-content bg-purple emphasize_green">总件数：</div>
          </el-col>
          <el-col :span="17">
            <div class="grid-content bg-purple emphasize_red" style="line-height: 20px;font-size: 20px;font-weight: bold;">{{ scanOrderInfo.pics }}</div>
          </el-col>
        </el-row>
        <!-- 半托多sku -->
        <el-row :gutter="20" v-if="scanOrderInfo.skuFlag?.indexOf('多sku') > -1">
          <el-col :span="7">
            <div class="grid-content bg-purple">扫码情况：</div>
          </el-col>
          <el-col :span="17">
            <div class="grid-content bg-purple" style="margin-bottom: 8px;">未扫<span class="emphasize_red" style="font-weight: bold;margin: 0 4px;">{{ this.scanOrderInfo.listTemp.length - hadScanCount }}</span>，已扫<span class="emphasize_green" style="font-weight: bold;margin: 0 4px;">{{ hadScanCount }}</span></div>
            <div class="other_sku">
              <div class="other_sku_item" v-for="(item, index) in ((scanOrderInfo.listTemp.length <= initShowCount && !expand) || expand) ? scanOrderInfo.listTemp : scanOrderInfo.listTemp.slice(0, initShowCount)" :key="index">
                <el-image fit="contain" style="cursor: pointer;border: 1px solid;width: 106px;height: 106px;" v-if="item.pickUrl" :src="item.pickUrl" @click="handleShowPicMaps([item.pickUrl])"></el-image>
                <div class="other_skuId">
                  <!-- <el-tooltip :content="item.itemSku" placement="top" effect="light">
                    <div class="text-ellipsis">{{ item.itemSku }}</div>
                  </el-tooltip> -->
                  <!-- <el-tooltip :content="toCm(item.properVal)" placement="top" effect="light">
                    <div class="text-ellipsis">{{ toCm(item.properVal) }}</div>
                  </el-tooltip> -->
                  <!-- <el-tooltip :content="item.proName" placement="top" effect="light">
                    <div class="text-ellipsis">{{ item.proName }}</div>
                  </el-tooltip> -->
                  <el-tooltip :content="item.appNo" placement="top" effect="light">
                    <div class="text-ellipsis">{{ item.appNo }}</div>
                  </el-tooltip>
                </div>
                <div v-if="item.qrStatus == '01'" class="other_scanStatus emphasize_green2">已扫</div>
                <div v-else-if="item.qrStatus == '03'" class="other_scanStatus emphasize_green2">部分出货</div>
                <div v-else class="other_scanStatus emphasize_red">未扫</div>
                <div class="other_num">x<span class="emphasize_red">{{ item.num }}</span></div>
              </div>
            </div>
            <div style="line-height: 36px; margin: -6px 0 0 0" v-if="scanOrderInfo.listTemp?.length > initShowCount">
              <span @click="handleExpand(scanOrderInfo.listTemp)" style="color: #4934b2;cursor: pointer;font-size: 14px;">{{ expand ? "收起" : "展开" }}（共{{ scanOrderInfo.listTemp.length }}个SKU）</span>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!-- 图片预览 -->
    <el-dialog :close-on-click-modal="false" title="图片预览" :visible.sync="previewImagesVisible" width="800px">
      <div class="preview-area">
        <div class="carousel">
          <el-carousel ref="carouselPreview" style="height: 500px; overflow: hidden" :autoplay="false" :interval="5000" arrow="always">
            <el-carousel-item style="height: 500px;" v-for="(productImage, index) in productImageList" :key="index">
              <img :src="productImage" />
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="preview-list">
          <div v-for="(productImage, index) in productImageList" :key="index" class="preview-list-item" :class="{ 'is-active': activeCarousel === index }" @click="handleClickPreviewImage(index)">
            <img :src="productImage" />
            <div class="preview-text">图片{{ index + 1 }}</div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 单图预览 -->
    <el-image ref="hintPic" v-show="false" :src="previewImg" alt="" style="width: 100px;height: 100px;" :preview-src-list="previewImgList"></el-image> 

  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "SetDevice",
  data() {
    return {
      // scanOrderInfo: {}
      previewImagesVisible: false,
      productImageList: [],
      activeCarousel: 0,
      expand: false,
      initShowCount: 3,
      mainPic: '',
      picBox: [],
      tempLength: 0,
      LabelTypeMap: {
        "1": "出商品标，不出箱标",
        "2": "不出商品标、不出箱标",
        "3": "出商品标、出箱标",
        "4": "不出商品标、出箱标",
      },
      previewImg: '',
      previewImgList: [],
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      },
    },
    scanOrderInfo: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
    showOfficialPic() {
      // if (['05','10','14'].includes(this.scanOrderInfo.platNo)) {
      //   return true
      // } else {
      //   return false
      // }
      if (this.scanOrderInfo.mapNote?.amazonPicUrl) {
        return true
      } else {
        return false
      }
    },
    wareColorClass() {
      // scanOrderInfo.mapNote?.warehousename
      const warehousename = this.scanOrderInfo.mapNote?.warehousename || ''
      if (this.scanOrderInfo.platNo == '05') {
        // 大件蓝色，义务一号仓 黑色，义务三号仓 绿色，其它红色
        if (warehousename.indexOf('大件') > -1) {
          return 'blue_color'
        } else if (warehousename.indexOf('义乌') > -1 && warehousename.indexOf('1号') > -1) {
          return 'black_color'
        } else if (warehousename.indexOf('义乌') > -1 && warehousename.indexOf('3号') > -1) {
          return 'emphasize_green'
        } else {
          return 'emphasize_red'
        }
      } else {
        // 除了义乌和大件，其他默认广东的
        if (warehousename.indexOf('大件') > -1) {
          return 'black_color'
        } else if (warehousename.indexOf('义乌') > -1) {
          return 'emphasize_green'
        } else {
          return 'emphasize_red'
        }
      }
    },
    hadScanCount() {
      return this.scanOrderInfo.listTemp.filter(item => item.qrStatus == '01').length
    }
  },
  watch: {
    scanOrderInfo: {
      handler(v) {
        this.expand = false
        this.mainPic = v.picUrl[0]
        this.picBox = [...new Set([...v.picUrl, ...v.picUrlAll])]
        this.events.$emit('copy-subOrder', { subOrder: v.subOrder })
      },
      deep: true,
    }
  },
  methods: {
    handleClose() {
      this.$emit("onClose")
    },
    handleShowPicMaps(list) {
      list = list || []
      this.productImageList = []
      for (let record of list) {
        this.productImageList.push(record)
      }
      this.activeCarousel = 0
      this.previewImagesVisible = true
      this.$nextTick(() => {
        this.$refs["carouselPreview"].setActiveItem(0)
      })
    },
    handleClickPreviewImage(index) {
      this.$refs["carouselPreview"].setActiveItem(index)
      this.activeCarousel = index
    },
    toCm(input) {
      if (input.indexOf('/') > -1 && input.toLowerCase().indexOf('/in') > -1) { //130x80cm/51x32in
        return input
      }
      if (this.dictData["bt_in_to_cm"]) {
        for (const item of this.dictData["bt_in_to_cm"]) {
          if (input.includes(item.label)) {
            return input.replace(item.label, item.value)
          }
        }
      }
      return input
    },
    handleExpand() {
      this.expand = !this.expand
    },
    hoverImg(e, url) {
      this.mainPic = url
    },
    prevPage() {
      let scrollDiv = $(".sku-pic-list .items ul") //进行移动动画的容器
      let scrollItems = $(".sku-pic-list .items ul li") //移动容器里的集合
      let moveLength = scrollItems.eq(0).width() * 1 + 12 //计算每次移动的长度
      if (this.tempLength > 0) {
        if (this.tempLength > moveLength) {
          scrollDiv.animate({ left: "+=" + moveLength + "px" }, 300)
          this.tempLength -= moveLength
        } else {
          scrollDiv.animate({ left: "+=" + this.tempLength + "px" }, 300)
          this.tempLength = 0
        }
      }
    },
    nextPage() {
      let scrollDiv = $(".sku-pic-list .items ul") //进行移动动画的容器
      let scrollItems = $(".sku-pic-list .items ul li") //移动容器里的集合
      let moveLength = scrollItems.eq(0).width() * 1 + 12 //计算每次移动的长度
      const myCount = this.showOfficialPic ? 2 : 3
      let countLength = (scrollItems.length - myCount) * scrollItems.eq(0).width() //计算总长度,总个数*单个长度
      if (this.tempLength < countLength) {
        if (countLength - this.tempLength > moveLength) {
          scrollDiv.animate({ left: "-=" + moveLength + "px" }, 300)
          this.tempLength += moveLength
        } else {
          scrollDiv.animate(
            { left: "-=" + (countLength - this.tempLength) + "px" },
            300
          )
          this.tempLength += countLength - this.tempLength
        }
      }
    },
    toPreview(url, list) {
      if (url && list.length>0) {
        this.previewImgList = list
        this.previewImg = url

        // 关键点：手动触发 el-image 的点击事件
        this.$nextTick(() => {
          // 通过 ref 找到组件并调用它的内部方法
          if (this.$refs.hintPic) {
            this.$refs.hintPic.clickHandler()
          }
        });
      }
    }
  },
};
</script>

<style scoped lang="scss">
.scan_order_info {
  .emphasize_red {
    color: #F56C6C;
  }

  .emphasize_green {
    color: #67c23a;
  }

  .emphasize_green2 {
    color: green;
  }

  .el-col-17 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .order_tags {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;

    .tags_item {
      font-weight: bold;
      margin-right: 4px;
      font-size: 15px;
    }
  }

  .curr_skuInfo {
    font-size: 16px;
  }

  .other_sku {
    display: flex;
    flex-wrap: wrap;
    font-size: 14px;
    max-height: 266px;
    overflow-y: auto;

    .other_sku_item {
      position: relative;
      // margin-bottom: 62px;
      margin-bottom: 22px;
      margin-right: 4px;
      width: 108px;

      .other_skuId {
        position: absolute;
        // bottom: -56px;
        top: 106px;
        background-color: #000000;
        width: 100%;
        text-align: center;
        color: #ffffff;

        .text-ellipsis {
          padding: 0 4px;
        }
      }

      .other_scanStatus {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        text-align: center;
        padding: 2px 8px;
        background-color: #0000004d;
        font-weight: bold;
      }

      .other_num {
        position: absolute;
        bottom: 10px;
        font-weight: bold;
        right: 10px;
      }
    }
  }

  // 图片预览
  .preview-area {
    overflow: hidden;

    .carousel {
      width: 600px;
      float: left;

      .el-carousel__item {
        text-align: center;
      }

      ::v-deep .el-carousel__container {
        height: 500px;
      }

      ::v-deep .el-carousel__indicators {
        display: none;
      }

      img {
        // width: 500px;
        height: 500px;
      }
    }

    .preview-list {
      width: 130px;
      float: left;
      height: 500px;
      margin: 0 0 0 16px;
      overflow-y: auto;

      .preview-list-item {
        border: 1px solid #e5e5e5;
        margin: 0 8px 15px 0;
        box-sizing: border-box;
        width: 111px;
        height: 111px;
        position: relative;
        cursor: pointer;
        text-align: center;

        .preview-text {
          display: none;
          position: absolute;
          bottom: 0;
          left: 0;
          text-align: center;
          width: 100%;
          background: rgba(0, 0, 0, 0.4);
          color: #fff;
          padding: 0.05rem 0;
          font-size: 0.14rem;
          z-index: 10;
          font-size: 14px;
        }

        &:hover .preview-text {
          display: block;
        }

        &.is-active .preview-text {
          display: block;
          background: #4934b2;
        }
      }

      img {
        // width: 109px;
        height: 109px;
      }

      .is-active {
        border: 1px solid #4934b2;
      }
    }

    .color-picker {
      overflow: hidden;
      margin: 16px 8px 0 0;

      ul {
        overflow: hidden;
        padding: 0px 0 0 266px;
      }
    }

    .color-picker-list li,
    .color-picker-list-hover li {
      background-color: #fff;
      width: 24px;
      height: 24px;
      border-radius: 4px;
      border: #d6d2d2 solid 1px;
      margin-left: 2px;
      padding: 1px;
      float: left;
    }

    .color-picker-list li.cur {
      border: #4934b2 solid 2px;
    }

    .color-picker-list li a,
    .color-picker-list-hover li a {
      width: 24px;
      height: 24px;
      display: table;
    }
  }
}

.shape1 {
  width: 50px;
  height: 50px;
  background-color: #000000;
  border-radius: 50%;
  margin: 0 auto;
}

.shape2 {
  width: 50px;
  height: 50px;
  background: #4934b2;
  clip-path: polygon(50% 30%, 0% 100%, 100% 100%);
  margin: 0 auto;
}

.shape3 {
  width: 50px;
  height: 50px;
  background-color: red;
  margin: 0 auto;
}

// 轮播图
.sku-pic-list {
  clear: both;
  margin-top: 16px;

  // width: 380px;
  // width: 330px;
  .prev,
  .next {
    display: block;
    font-family: "宋体";
    text-align: center;
    width: 17px;
    height: 70px;
    background-color: #fafafa;
    cursor: pointer;
    text-decoration: none;
    padding: 23px 14px 2px 9px;
    color: #aaaaaa;
    border-radius: 15px;
    margin: 6px 0 0 0;
    font-size: 12px;
    font-weight: bold;
    box-sizing: border-box;

    &:hover {
      background-color: #eeeeee;
    }
  }

  .prev {
    float: left;
    margin-right: 4px;
  }

  .next {
    float: right;
  }

  .items {
    float: left;
    position: relative;
    // width: 312px;
    // width: 262px;
    height: 86px;
    overflow: hidden;
    padding: 0 8px;
    box-sizing: border-box;

    ul {
      position: absolute;
      width: 99999px;
      height: 86px;
      margin-top: 0px;
      margin-bottom: 0px;
      padding-left: 0px;
      list-style-type: none;

      li {
        float: left;
        width: 86px;
        height: 86px;
        margin-right: 8px;
        text-align: center;
        position: relative;

        .index {
          position: absolute;
          width: 17px;
          height: 17px;
          border-radius: 50%;
          left: 9px;
          top: 5px;
          background: #4934b2;
          color: #ffffff;
          font-size: 12px;
          line-height: 17px;
        }

        .img-normal {
          width: 80px;
          height: 80px;
          padding: 1px;
          border-radius: 12px;
          object-fit: contain;

          &:hover {
            border: 2px solid #4934b2;
            padding: 1px;
          }
        }

        .img-select {
          border: 2px solid #4934b2 !important;
        }
      }
    }
  }
}

.w_380 {
  width: 380px;
}

.w_330 {
  width: 330px;
}

.w_312 {
  width: 312px;
}

.w_262 {
  width: 262px;
}
.normal_style {
  line-height: 20px;
  font-size: 20px;
  font-weight: bold;
}
.blue_color {
  color: #4934b2;
}
.black_color {
  color: #000000;
}
</style>